  import React from "react";
import { ToastContainer } from "react-toastify";

    const OrderActionModals = ({

  deliverModalOrder,
  setDeliverModalOrder,
  handleConfirmDelivered,

  showSummaryModal,
  setShowSummaryModal,
  selectedSummaryDate,
  setSelectedSummaryDate,
  summaryActionLoading,
  handlePrintSummary,
  handleDownloadSummaryExcel,

  showMergedModal,
  setShowMergedModal,
  selectedMergedDate,
  setSelectedMergedDate,
  mergedSummaryActionLoading,
  handlePrintMergedSummary,
  handleDownloadMergedSummaryExcel,

  cancelModalOrder,
  setCancelModalOrder,
  openCancelDropdown,
  setOpenCancelDropdown,
  cancelReason,
  setCancelReason,
  cancelReasons,
  userID,
  updateOrderStatus,
}) => {
    return (
      <>
         
         <ToastContainer/>
         {/* Mark as delivered model */}
          {deliverModalOrder && (
            <div className="fixed inset-0 z-[9999] bg-black/40 flex justify-center montserrat-font-1 items-center">
              <div
                className="bg-white rounded-lg w-[400px] shadow-lg p-5"
                onClick={(e) => e.stopPropagation()}
              >
                {/* Header */}
                <div className="flex justify-between items-center mb-3 montserrat-font-1">
                  <h2 className="text-lg font-semibold">Mark as Delivered</h2>
                  <button onClick={() => setDeliverModalOrder(null)}>✕</button>
                </div>

                {/* Body */}
                <div className="text-center text-gray-600 mb-5 montserrat-font-2">
                  Are you sure you want to mark this order as{" "}
                  <span className="text-green-600 font-semibold">
                    Delivered?
                  </span>
                </div>

                {/* Footer */}
                <div className="flex justify-end gap-2">
                  <button
                    onClick={() => setDeliverModalOrder(null)}
                    className="px-4 py-1.5 border rounded"
                  >
                    Cancel
                  </button>

                  <button
                    onClick={handleConfirmDelivered}
                    className="px-4 py-1.5 bg-green-600 text-white rounded"
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* print summary model */}

          {showSummaryModal && (
            <div
              className="fixed inset-0 z-[99999] bg-black/40 flex justify-center items-center montserrat-font-1"
              onMouseDown={(e) => e.stopPropagation()}
              onPointerDown={(e) => e.stopPropagation()}
            >
              <div
                className="bg-white rounded-lg w-[400px] shadow-lg p-5"
                onMouseDown={(e) => e.stopPropagation()}
                onPointerDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex justify-between items-center mb-3 montserrat-font-1">
                  <h2 className="text-lg font-semibold">Summary Report</h2>
                  <button
                    type="button"
                    onClick={() => {
                      if (!summaryActionLoading) {
                        setShowSummaryModal(false);
                      }
                    }}
                  >
                    ✕
                  </button>
                </div>

                <div className="mb-4">
                  <label className="text-sm font-medium">Select Date</label>
                  <input
                    type="date"
                    value={selectedSummaryDate}
                    onChange={(e) => setSelectedSummaryDate(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onPointerDown={(e) => e.stopPropagation()}
                    className="border px-3 py-2 rounded w-full mt-2 bg-white"
                  />
                </div>

                <div className="flex justify-end gap-2 flex-wrap">
                  <button
                    type="button"
                    disabled={summaryActionLoading}
                    onClick={() => setShowSummaryModal(false)}
                    className={`px-4 py-1.5 border rounded-lg text-white ${
                      summaryActionLoading
                        ? "bg-gray-300 cursor-not-allowed"
                        : "bg-gray-500"
                    }`}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    disabled={summaryActionLoading}
                    className={`px-4 py-1.5 border rounded-lg text-white ${
                      summaryActionLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-500"
                    }`}
                    onClick={handlePrintSummary}
                  >
                    {summaryActionLoading ? "Please wait..." : "Print"}
                  </button>

                  <button
                    type="button"
                    disabled={summaryActionLoading}
                    className={`px-4 py-1.5 border rounded-lg text-white ${
                      summaryActionLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-500"
                    }`}
                    onClick={handleDownloadSummaryExcel}
                  >
                    {summaryActionLoading ? "Please wait..." : "Excel"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* merged summary model */}

          {showMergedModal && (
            <div
              className="fixed inset-0 z-[99999] bg-black/40 flex justify-center items-center montserrat-font-1"
              onMouseDown={(e) => e.stopPropagation()}
              onPointerDown={(e) => e.stopPropagation()}
            >
              <div
                className="bg-white rounded-lg w-[400px] shadow-lg p-5"
                onMouseDown={(e) => e.stopPropagation()}
                onPointerDown={(e) => e.stopPropagation()}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex justify-between items-center mb-3 montserrat-font-1">
                  <h2 className="text-lg font-semibold">Merged Summary</h2>
                  <button
                    type="button"
                    onClick={() => {
                      if (!mergedSummaryActionLoading) {
                        setShowMergedModal(false);
                      }
                    }}
                  >
                    ✕
                  </button>
                </div>

                <div className="mb-4">
                  <label className="text-sm font-medium">Select Date</label>
                  <input
                    type="date"
                    value={selectedMergedDate}
                    onChange={(e) => setSelectedMergedDate(e.target.value)}
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onPointerDown={(e) => e.stopPropagation()}
                    className="border px-3 py-2 rounded w-full mt-2 bg-white"
                  />
                </div>

                <div className="flex justify-end gap-2 flex-wrap">
                  <button
                    type="button"
                    disabled={mergedSummaryActionLoading}
                    onClick={() => setShowMergedModal(false)}
                    className={`px-4 py-1.5 border rounded-lg text-white ${
                      mergedSummaryActionLoading
                        ? "bg-gray-300 cursor-not-allowed"
                        : "bg-gray-400"
                    }`}
                  >
                    Cancel
                  </button>

                  <button
                    type="button"
                    disabled={mergedSummaryActionLoading}
                    className={`px-4 py-1.5 border rounded-lg text-white ${
                      mergedSummaryActionLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-green-500"
                    }`}
                    onClick={handlePrintMergedSummary}
                  >
                    {mergedSummaryActionLoading ? "Please wait..." : "Print"}
                  </button>

                  <button
                    type="button"
                    disabled={mergedSummaryActionLoading}
                    className={`px-4 py-1.5 border rounded-lg text-white ${
                      mergedSummaryActionLoading
                        ? "bg-gray-400 cursor-not-allowed"
                        : "bg-blue-500"
                    }`}
                    onClick={handleDownloadMergedSummaryExcel}
                  >
                    {mergedSummaryActionLoading ? "Please wait..." : "Excel"}
                  </button>
                </div>
              </div>
            </div>
          )}

          {/* cancel modal */}
          
          {cancelModalOrder && (
            <div className="fixed inset-0 z-[9999] bg-black/40 flex justify-center items-center montserrat-font-1">
              <div
                className="bg-white rounded-lg w-[400px] montserrat-font-1 shadow-lg p-4"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="flex justify-between items-center mb-3 montserrat-font-1">
                  <h2 className="text-lg font-semibold">Cancel Order</h2>
                  <button onClick={() => setCancelModalOrder(null)}>✕</button>
                </div>

                <div className="mb-5 mt-4 text-lg text-gray-600 text-center montserrat-font-2">
                  Are you sure you want to cancel this order?
                  <br />
                  <span className="text-red-500 font-medium montserrat-font-2">
                    This action cannot be undone.
                  </span>
                </div>

                <div className="mb-4">
                  <p className="text-sm font-medium mb-2">Select Reason</p>

                  <div
                    onClick={() => setOpenCancelDropdown(!openCancelDropdown)}
                    className="border px-3 py-2 rounded cursor-pointer flex justify-between items-center"
                  >
                    <span className="text-sm">
                      {cancelReason || "Select reason"}
                    </span>
                    <span>▼</span>
                  </div>

                  {openCancelDropdown && (
                    <div className="border mt-1 rounded bg-white shadow">
                      {cancelReasons.map((reason) => (
                        <div
                          key={reason}
                          onClick={() => {
                            setCancelReason(reason);
                            setOpenCancelDropdown(false);
                          }}
                          className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer"
                        >
                          {reason}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <div className="flex justify-end gap-2">
                  <button
                    onClick={() => setCancelModalOrder(null)}
                    className="px-4 py-1.5 border rounded"
                  >
                    Close
                  </button>

                  <button
                    disabled={!cancelReason}
                    onClick={async () => {
                      const payload = {
                        userid: userID,
                        orderid: cancelModalOrder.orderid,
                        productid: "",
                        status: "rejected",
                        time: "",
                        payment: "",
                        remark: cancelReason,
                      };

                      await updateOrderStatus(payload);

                      setCancelReason("");
                      setCancelModalOrder(null);
                    }}
                    className={`px-4 py-1.5 rounded text-white ${
                      cancelReason
                        ? "bg-red-600"
                        : "bg-gray-300 cursor-not-allowed"
                    }`}
                  >
                    Confirm Cancel
                  </button>
                </div>
              </div>
            </div>
          )}
          </>
       );
};

export default OrderActionModals;